import Image from "next/image";
import { _, _c } from "../../../../services/text-services";
// @ts-ignore
import styles from "./recommanded-product.component.module.scss";
// @ts-ignore
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import playIcon from "../../../../../shared-assets/images/player/play-btn.png";
import { Product } from "../../../../models/home-rows";
import AppContext from "../../../../services/app-context-services";
import { ROUTES } from "../../../../services/router-services";
import Link from "next/link";
import Imagic from "../../../../components/imagic/imagic";
import { trackEvent } from "../../../../services/ga-services";
interface FeatureItemProps {
  product: Product;
  title: string;
}


function AppRecommandedProduct({ product, title }: FeatureItemProps) {
  const {isIntlUser, setShowLoginPopup} = useContext(AppContext);
  const [url, setUrl] = useState("");


  useEffect(() => {
    if (!product?.id || (isIntlUser && false)) return;
    setUrl(ROUTES.product(product));

  }, [product?.product_type, product?.id, product?.name_english]);

  const content = <>
    {(product?.feature_avatar?.xhdpi || product?.feature_avatar?.hdpi) && (
      <Imagic
        className={_c(styles, "image")}
        src={product?.feature_avatar?.xhdpi || product?.feature_avatar?.hdpi || ""}
        alt="product.name"
        width="384"
        height="240"
      //loader={simpleLoader}
      />
    )}
    {product?.name && (
      <div className={_c(styles, "name")}>{_(product.name)}</div>
    )}
    <div className={_c(styles, "shadow shadow-mask")} />
    {product?.name && (
      <div className={_c(styles, "shadow shadow-name")}>
        {_(product.name)}
      </div>
    )}
    <div className={_c(styles, "shadow shadow-play")}>
      <Image
        src={playIcon}
        alt="پخش"
        className={"img-fluid"}
        width="45"
        height="45"
      //loader={simpleLoader}
      />
    </div>
    {product?.approved_age && (
      <div className={_c(styles, "shadow shadow-age")}>
        <span>{_(product.approved_age.toString())}+</span>
      </div>
    )}
  </>

  return (
    <div
      className={_c(styles, "product")}
    >
      <Link href={url} prefetch={false}><a>{content}</a></Link>
    </div>
  );
}

export default AppRecommandedProduct;
